import { render, staticRenderFns } from "./AddSong.vue?vue&type=template&id=12b9196f&scoped=true&"
import script from "./AddSong.vue?vue&type=script&lang=js&"
export * from "./AddSong.vue?vue&type=script&lang=js&"
import style0 from "./AddSong.vue?vue&type=style&index=0&id=12b9196f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b9196f",
  null
  
)

export default component.exports